const MilkRunToDo = () => import("./MilkRunToDo")
import store from "../../store"

const ifAuthenticated = (to, from, next) => {
    if (store.getters.isLoggedIn) {
        next()
        return
    }
    next('/login')
}

export default [
    {
        path: '/milkrun/missioni',
        name: 'MilkRunMissions',
        meta: {menu: 'milkrun', title: 'Missioni MilkRun'},
        component: () => import('./missions/MilkRunMissions.vue'),
        beforeEnter: ifAuthenticated,
    },
    {
        path: '/milkrun/todo',
        name: 'MilkRunToDo',
        meta: {menu: 'milkrun', title: 'MilkRun ToDo'},
        component: MilkRunToDo,
        beforeEnter: ifAuthenticated,
    },
]
